module.exports = __webpack_public_path__ + "img/1-2.338e5e18.jpg";